<template>
  <div class="code-set-dialog">
    <!-- <DsfNavTree :hasHeader="false" /> -->
    <!-- :filter-node-method="filterNode" -->
    <el-input
      placeholder="请输入搜索内容"
      v-model="searchValue"
      clearable
      @input="listenInput"
    >
      <i slot="suffix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <div class="selected-valus">
      <p class="current-selected">当前选中：</p>
      <span v-if="checkedNode.length === 0">暂未选择！</span>
      <div class="values-box" v-else>
        <div class="values">
          <p>{{ showlabel }}</p>
          <span v-if="total > 1">(+{{ total }})</span>
        </div>
      </div>
    </div>
    <div class="code-set-container">
      <DsfVirtualScroll @scroll="scroll" id="code-set-virtual-scroll-box">
        <!-- 搜索时展示的树 -->
        <el-tree
          v-show="searchValue"
          ref="tree"
          :node-key="$fnode.areaselect ? 'value' : 'id'"
          :empty-text="loadingTree ? '数据加载中，请稍候...' : '暂无数据'"
          :default-checked-keys="defaultKeys"
          :default-expanded-keys="defaultexpandedKeys"
          :data="showSearchItems"
          :props="treeDefaultProps"
          :default-expand-all="false"
          :highlight-current="true"
          :expand-on-click-node="false"
          :show-checkbox="$fnode.multiple"
          :check-on-click-node="!$fnode.multiple"
          :check-strictly="strictly"
          :accordion="$fnode.accordion"
          @check="check"
          @node-click="nodeClick"
          @check-change="checkChange"
          @current-change="currentNodeChange"
        >
          <span class="show-hide custom-tree-node" slot-scope="{ node }">
            <!-- <template v-if="!config.multiple">
              <span>
                <el-radio
                  v-if="strictly || !data.children"
                  v-model="checkradio"
                  :label="config.areaselect ? data.value : data.id"
                  @change="radioChange(data)"
                ><br/></el-radio>
              </span>
            </template> -->
            <span>{{ node.label }}</span>
          </span>
          <template v-slot:empty>
            <dsf-empty-data v-if="!loadingTree"></dsf-empty-data>
            <div v-else>
              <i class="el-icon-loading"></i>
              数据加载中，请稍候...
            </div>
          </template>
        </el-tree>

        <!-- 正常树 -->
        <el-tree
          v-show="!searchValue"
          ref="tree"
          :node-key="$fnode.areaselect ? 'value' : 'id'"
          :empty-text="loadingTree ? '数据加载中，请稍候...' : '暂无数据'"
          :default-checked-keys="defaultKeys"
          :default-expanded-keys="defaultexpandedKeys"
          :data="iszdyjk ? initItems : realItems"
          :props="treeDefaultProps"
          :default-expand-all="false"
          :highlight-current="true"
          :expand-on-click-node="false"
          :show-checkbox="$fnode.multiple"
          :check-on-click-node="!$fnode.multiple"
          :check-strictly="strictly"
          :lazy="isLazy"
          :accordion="$fnode.accordion"
          :load="loadNode"
          @check="check"
          @node-click="nodeClick"
          @check-change="checkChange"
          @current-change="currentNodeChange"
        >
          <span class="show-hide custom-tree-node" slot-scope="{ node }">
            <!-- <template v-if="!config.multiple">
              <span>
                <el-radio
                  v-if="strictly || !data.children"
                  v-model="checkradio"
                  :label="config.areaselect ? data.value : data.id"
                  @change="radioChange(data)"
                ><br/></el-radio>
              </span>
            </template> -->
            <span>{{ node.label }}</span>
          </span>
          <template v-slot:empty>
            <dsf-empty-data v-if="!loadingTree"></dsf-empty-data>
            <div v-else>
              <i class="el-icon-loading"></i>
              数据加载中，请稍候...
            </div>
          </template>
        </el-tree>
      </DsfVirtualScroll>
    </div>
  </div>
</template>
<script>
export default {
  name: "CodeSetDialog",
  ctrlCaption: "代码集弹窗",
  mixins: [$mixins.control],
  props: {
    $fnode: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    field() {
      return {
        textField: this.$fnode.keysMap[0].from,
        valueField: this.$fnode.keysMap[1].from,
        pidField: this.$fnode.keysMap[2].from,
        childrenField: this.$fnode.keysMap[3].from,
        levelField: this.$fnode.keysMap[4].from,
      };
    },
    // 是否开启懒加载
    isLazy() {
      if (this.$fnode.areaselect) return true;
      return this.$fnode.isLazy;
    },
    iszdyjk() {
      if (this.$fnode.areaselect) return false;
      return this.$fnode.iszdyjk;
    },
    dataUrl() {
      if (this.$fnode.isLazy) return this.$fnode.lazyUrl;
      return this.$fnode.initDataSourceUrl;
    },
    realItems() {
      if (this.isDesign) {
        return [];
      }

      if (this.$fnode.initDataSourceUrl || this.$fnode.lazyUrl) {
        return [];
      } else if (!this.$fnode.areaselect) {
        let items = [];
        let $itemsCopy = _.cloneDeep(this.$fnode.realItems);
        let values = _.cloneDeep(this.$fnode.value);

        dsf.deepForEach(
          $itemsCopy,
          (item, level, index, parent) => {
            item.id = dsf.uuid();
            if (!parent) {
              item.fulltext = item[this.field.textField];
            } else {
              item.fulltext = `${parent.fulltext}${
                this.$fnode?.separator || "/"
              }${item[this.field.textField]}`;
            }

            item.pid = parent ? parent.id : null;
            if (!item.pid) items.push(item);

            if (
              dsf.isArray(values) &&
              values.some((v) => v.text === item.text && v.value === item.value)
            ) {
              if (this.$fnode.multiple) {
                this.defaultKeys.push(item.id);
              }
            }
          },
          {
            children: this.field.childrenField,
          }
        );

        return items;
      } else {
        return this.areaItems;
      }
    },
    strictly() {
      return this.$fnode.checkStrictly;
    },
    treeDefaultProps() {
      if (this.field.textField && this.field.childrenField) {
        return {
          label: this.field.textField,
          children: this.field.childrenField,
          isLeaf: "isLeaf",
        };
      }
      return {
        label: "text",
        children: "children",
        isLeaf: "isLeaf",
      };
    },
    showlabel() {
      let result = "";
      let selected = _.cloneDeep(this.checkedNode);
      if (selected.length > 0) {
        result = this.$fnode.showAllLevels
          ? selected[0]?.fulltext || selected[0].text
          : selected[0].text;
      }
      return result;
    },
    total() {
      if (!this.$fnode.multiple) return 1;
      let selected = _.cloneDeep(this.checkedNode).filter((s) => {
        if (!this.$fnode.checkStrictly) {
          return !s.children;
        }
        return s;
      });
      return selected.length;
    },
  },
  data() {
    return {
      searchValue: "",
      checkedNode: [],
      defaultKeys: [],
      defaultexpandedKeys: [],
      areaItems: [],
      searchItems: [],
      showSearchItems: [],
      initItems: [],
      loadingTree: false,
      pageIndex: 1,
      virtualScrollBoxHeight: null,
      treeItemHeight: null,
      virtualScrollPageSize: 40,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.initScroll();

    if (this.$fnode.multiple) {
      this.checkedNode = this.$refs.tree.getCheckedNodes();
    }
  },
  methods: {
    init() {
      // 查询防抖
      if (this.$fnode.areaselect) {
        this.getareas = _.debounce(() => {
          this.getAreaByinput();
        }, 500);
      } else {
        this.searchTree = _.debounce(() => {
          this.searchTreeByinput();
        }, 500);
      }

      // 滚动节流
      this.scrollLoad = _.throttle((scrollTop) => {
        this.scrollLoadTree(scrollTop);
      }, 100);

      // 已选回显
      if (this.$fnode.value && Object.keys(this.$fnode.value).length != 0) {
        try {
          this.checkedNode = [];
          let checkedNodes = _.cloneDeep(this.$fnode.value);
          if (this.$fnode.multiple) {
            // multiple
          } else {
            if (dsf.isObject(checkedNodes)) {
              this.checkedNode.push(checkedNodes);
            }
          }
        } catch (e) {
          this.checkedNode = [];
        }
      }

      // 自定义接口加载第一级
      if (this.iszdyjk && !this.$fnode.areaselect) {
        this.loadTreeFirstLevNode();
      }
    },
    initScroll() {
      // 初始化滚动加载所需值
      try {
        let dom =
          Array.from(
            document.querySelectorAll("#code-set-virtual-scroll-box")
          ) || [];
        if (dom?.[0]) {
          dom = dom[0];
          // 滚动盒高度
          this.virtualScrollBoxHeight = dom?.clientHeight || null;
          if (this.virtualScrollBoxHeight) {
            // 滚动盒内显示个数
            // el-tree 单个高度为 30 ， style 样式中设定
            // 多加几个以免内容撑不满
            this.virtualScrollPageSize =
              Math.floor(this.virtualScrollBoxHeight / 30) + 5;
          }
        }
      } catch (error) {
        //
      }
    },
    scroll(e) {
      let sTop = e.target.scrollTop;
      this.scrollLoad(sTop);
    },
    scrollLoadTree(sTop) {
      this.computedTreeShowData(false, sTop);
    },
    loadTreeFirstLevNode() {
      this.$http
        .get(this.dataUrl, {
          query: JSON.stringify({
            searchValue: "",
          }),
        })
        .done(({ success, data, message }) => {
          if (success && dsf.isArray(data)) {
            _.forEach(data, (it) => {
              let item = _.cloneDeep(it);
              item[this.field.textField] = it.name;
              item[this.field.valueField] = it.id;
              this.initItems.push(item);
            });
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message(err?.message || "请求异常", false);
        })
        .always(() => {
          this.loadingTree = false;
        });
    },
    computedTreeShowData(firstRender = false, scrollTop = 0) {
      this.showSearchItems = [];
      let num = 0;
      if (!firstRender) {
        num = Math.floor(scrollTop / 30);
      }

      _.forEach(this.searchItems, (it, index) => {
        if (index < this.virtualScrollPageSize + num)
          this.showSearchItems.push(it);
      });
    },
    async loadTreeNodeChildren(pid) {
      let res = [];
      if (pid) {
        await this.$http
          .get(this.$fnode.lazyChildrenUrl, {
            pid: pid,
          })
          .done(({ success, data, message }) => {
            if (success && dsf.isArray(data)) {
              _.forEach(data, (it) => {
                let item = _.cloneDeep(it);
                item[this.field.textField] = it.name;
                item[this.field.valueField] = it.id;
                res.push(item);
              });
            }
          });
      }
      return res;
    },
    input(e) {
    },
    check(e) {
      let params = {
        data: e,
        selected: []
      };
      if (this.$fnode.multiple) {
        params.selected = this.$refs.tree.getCheckedNodes();
      }
      this.$fnode.checkChange(params)
    },
    checkChange(e) {
      if (this.$fnode.multiple) {
        this.checkedNode = [];
        let checkNodes = this.$refs.tree.getCheckedNodes();
        checkNodes.forEach((n) => this.checkedNode.push(n));
      }
    },
    radioChange(row) {
      this.checkedNode.length === 0
        ? this.checkedNode.push(row)
        : this.$set(this.checkedNode, 0, row);
      this.$refs.tree.setCurrentNode(row);
    },
    currentNodeChange(e) {},
    nodeClick(row) {
      if (!this.$fnode.multiple) {
        this.checkedNode.length === 0
          ? this.checkedNode.push(row)
          : this.$set(this.checkedNode, 0, row);

        // this.checkedNode.length === 0 ? this.checkedNode.push(row) : this.$set(this.checkedNode, 0, row);
        // this.$refs.tree.setCurrentNode(row);
      }
    },
    filterNode(value, data) {
      if (!this.$fnode.areaselect) {
        if (!value) return true;
        return data.text.indexOf(value) !== -1;
      }
    },
    listenInput() {
      if (this.$fnode.areaselect) {
        this.loadingTree = true;
        if (this.searchValue) {
          this?.getareas();
        } else {
          this.getArea("000000000000", 2, 2, null, true);
        }
      } else {
        this.loadingTree = true;
        this.searchItems = [];
        this.showSearchItems = [];
        if (this.searchValue) {
          this.$nextTick(() => {
            this.searchTree();
          });
        }
      }
    },
    searchTreeByinput() {
      this.$http
        .get(this.$fnode.lazySearchUrl, {
          keyWord: this.searchValue,
        })
        .done(({ success, data, message }) => {
          if (success && dsf.isArray(data)) {
            _.forEach(data, (it) => {
              let item = {};
              item[this.field.textField] = it.name;
              item[this.field.valueField] = it.id;
              this.searchItems.push(item);
            });

            this.computedTreeShowData(true);
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .always(() => {
          this.loadingTree = false;
        });
    },
    async loadNode(node, resolve) {
      if (this.$fnode.areaselect) {
        if (this.searchValue) {
          return resolve(node.data?.children || []);
        } else {
          let LEVEL = node.level ? node.level + 2 : 2;
          let ID = node.data.treeinfo_globalid;
          this.getArea(ID, LEVEL, LEVEL, (data) => {
            let childNode = [];
            _.forEach(data, (d) => {
              let t = {};
              t[`${this.field.valueField}`] = d.dsfa_area_id;
              t[`${this.field.textField}`] = d.name;
              t[`${this.field.aliasField}`] = d.alias;
              t[`${this.field.childrenField}`] = [];
              t.fulltext = d.name;
              t.pid = d.treeinfo_pid;
              t.level = d.treeinfo_level;
              t.treeinfo_globalid = d.treeinfo_globalid;
              t.isLeaf = LEVEL === 6;
              childNode.push(t);
            });
            return resolve(childNode);
          });
        }
      } else {
        if (this.iszdyjk && !this.searchValue) {
          let children = await this.loadTreeNodeChildren(node.data?.value);
          return resolve(children);
        } else if (!this.iszdyjk) {
          if (node.level === 0) return resolve(node.data);

          let children = [];
          if (dsf.isArray(node.data?.children)) {
            _.forEach(node.data.children, (it) => {
              let itCopy = _.cloneDeep(it);
              if (!dsf.isArray(it?.children)) itCopy.isLeaf = true;
              children.push(itCopy);
            });
          }
          return resolve(children);
        }
      }
    },
    getArea(
      TREEINFO_GLOBALID = "000000000000",
      END_LEVEL = 2,
      START_LEVEL = 2,
      func = null,
      init = false
    ) {
      this.$http
        .get(
          "area/getArea",
          {
            TREEINFO_GLOBALID: TREEINFO_GLOBALID,
            END_LEVEL: END_LEVEL,
            START_LEVEL: START_LEVEL,
          },
          {
            cache: true,
            headers: {
              "Cache-Control": "public",
            },
          }
        )
        .done(({ success, data, message }) => {
          if (func) {
            func(data);
            return;
          }

          if (success) {
            this.initAreaItem(data, init);
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message(err?.message || "请求异常", false);
        })
        .always(() => {
          this.loadingTree = false;
        });
    },
    getAreaByinput() {
      this.$http
        .get(`/area/selectArea?keyword=${this.searchValue}`)
        .done(({ success, data, message }) => {
          if (success) {
            Array.isArray(data) && this.initAreaItem(data, true);
          }
        })
        .error((err) => {
          dsf.layer.message(err?.message || "请求异常", false);
        })
        .always(() => {
          this.loadingTree = false;
        });
    },
    initAreaItem(data, init = false) {
      data = _.cloneDeep(data);
      const _this = this;
      this.defaultexpandedKeys = [];
      dsf.deepForEach(data, (d, level, index, parent) => {
        if (!parent) {
          d.fulltext = d.name;
        } else {
          d.fulltext = `${parent.fulltext}${this.$fnode?.separator || "/"}${
            d.name
          }`;
        }
        d[`${_this.field.valueField}`] = d.dsfa_area_id;
        d[`${_this.field.textField}`] = d.name;
        d[`${_this.field.aliasField}`] = d.alias;
        d[`${_this.field.childrenField}`] = d.children || [];
        d.pid = d.treeinfo_pid;
        d.level = d.treeinfo_level;
        d.treeinfo_globalid = d.treeinfo_globalid;
        d.isLeaf = d.treeinfo_level === 6;

        if (
          _this.searchValue &&
          !_this.defaultexpandedKeys.some((key) => key === d.dsfa_area_id)
        ) {
          _this.defaultexpandedKeys.push(d.dsfa_area_id);
        }
      });

      if (init) _this.areaItems = [];
      _this.$nextTick(() => {
        _.forEach(data, (d) => this.areaItems.push(d));
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.code-set-dialog {
  height: calc(100% - 16px);
  padding: 8px 8px 0;
  overflow: hidden;
  .selected-valus {
    margin-bottom: 16px;
    padding: 4px 0;
    display: flex;
    align-items: center;
    height: 40px;
    border-bottom: 1px solid #000;
    .current-selected {
      color: #000;
      flex-shrink: 0;
    }
    span {
      color: #999;
    }
    .values-box {
      flex: 1;
      display: flex;
      flex-shrink: 0;
      overflow: hidden;
      .values {
        display: flex;
        align-items: center;
        max-width: calc(100% - 32px);
        height: 28px;
        background-color: #eaeaea;
        border-radius: 3px;
        padding: 0 16px;
        border: 1px solid #c0c4cc;
        overflow: hidden;
        p {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          display: inline-block;
          margin-left: 8px;
          flex-shrink: 0;
        }
      }
    }
  }
  .selected-valus,
  .el-input {
    flex-shrink: 0;
  }
  .code-set-container {
    height: calc(100% - 105px);
  }
  .el-tree ::v-deep.el-tree-node__content {
    height: 30px !important;
    line-height: 30px !important;
  }
}
</style>
